import { useStaticQuery, graphql } from "gatsby"

export const useNewsletter = () => {
  const data = useStaticQuery(
    graphql`
      query {
        newsletters {
          newsletters {
            id
            name
          }
        }
      }
    `
  )
  return data
}
